angular.module('impactx.deliverynote').controller('DeliveryNoteCtrl', DeliveryNoteCtrl);
DeliveryNoteCtrl.$inject = [
    '$scope',
    'dataGen',
    'selectedListItems',
    '$mdToast',
    '$mdDialog',
    '$redirect',
    'BackService',
    '$routeParams',
    'OutsourcedCommentSaveService',
    'ProductSelectionService',
    '$filter',
    'ToastService',
    'TranslationService',
    'ToolbarService',
    '$errorHandler',
    '$rootScope'
];

function DeliveryNoteCtrl($scope, dataGen, selectedListItems, $mdToast, $mdDialog, $redirect, BackService, $routeParams,
                          OutsourcedCommentSaveService, ProductSelectionService, $filter, ToastService, TranslationService,
                          ToolbarService, $errorHandler, $rootScope) {
    var self = this;
    var pohid = $routeParams.pohid;
    var dnhId = $routeParams.id;
    var orderItemIds = $redirect.getLastParameters();
    var previousLocation = $rootScope.previousLocation ? $rootScope.previousLocation : null;
    $scope.selectedItems = [];
    $scope.onDeliveryCompanySelect = function (selected) {
        if (selected != null) {
            $scope.filterOrder($scope.data.dnh.supplierCompany.selected.id, selected.id);
        }
        else {
            $scope.orderNumbers = [];
            $scope.data.dnh.poh.selected = {};
        }
    };
    $scope.onSupplierCompanySelect = function (selected) {
        if (selected != null) {
            $scope.filterOrder(selected.id, $scope.data.dnh.deliveryCompany.selected.id);
        }
        else {
            $scope.orderNumbers = [];
            if ($scope.data.dnh.poh) {
                $scope.data.dnh.poh.selected = {};
            }
        }
    };
    $scope.filterOrder = function (supplierId, deliveryCOMId) {
        if ($scope.data.dnh.poh && $scope.data.dnh.poh.entries) {
            $scope.orderNumbers = [];
            var selectedPOHId = 0;
            if ($scope.data.dnh.poh.selected) {
                selectedPOHId = $scope.data.dnh.poh.selected.id;
            }
            var selectedFound = false;
            for (var i = 0; i < $scope.data.dnh.poh.entries.length; i++) {
                var pohEntry = $scope.data.dnh.poh.entries[i];
                if (pohEntry.supplierId == supplierId && pohEntry.deliveryCOMId == deliveryCOMId) {
                    $scope.orderNumbers.push(pohEntry);
                    if (pohEntry.id == selectedPOHId) {
                        selectedFound = true;
                    }
                }
            }
            if (!selectedFound) {
                $scope.data.dnh.poh.selected = [];
                if ($scope.orderNumbers.length == 1) {
                    $scope.data.dnh.poh.selected = $scope.orderNumbers[0];
                }
            }
        }
    };

    $scope.showAttachments = false;

    $scope.toggleAttachments = function () {
        $scope.showAttachments = !$scope.showAttachments;
    };

    $scope.saveAndCloseDeliveryNoteDialog = function (evt) {
        var tempData = angular.copy($scope.data.dnh);
        OutsourcedCommentSaveService.extractComments(tempData);

        return dataGen.postAsForm({}, {
            dnhDTO: tempData
        }, "/deliverynote/validateSaveAndClose").then(function () {
            $scope.saveAndCloseDeliveryNoteDialogFinal(evt);
        })
    };

    $scope.saveAndCloseDeliveryNoteDialogFinal = function (evt) {
        var tempData = angular.copy($scope.data.dnh);
        OutsourcedCommentSaveService.extractComments(tempData);
        dataGen.postAsForm({}, {dnhDTO: tempData}, "/deliverynote/check").then(function(checkResult) {
            if(checkResult.data) {
                if($scope.data.dnh.forSupplier || (!checkResult.data.hasErrors && checkResult.data.noComplaintForCorrectDelivery &&
                    !checkResult.data.hasOvershipment && !checkResult.data.hasPartialDelivery)) {
                    // no complaint for correct delivery notes, close directly
                    var extractedComments = OutsourcedCommentSaveService.extractComments($scope.data.dnh);
                    $scope.data.dnh.acceptOthers = true;
                    var dataObj = {
                        data: $scope.data,
                        fromReadOnly: false,
                        skippedErrors: $scope.skipErrors
                    };
                    dataGen.post($scope, dataObj, "/deliverynote/saveAndClose").then(function (data) {
                        $scope.clearSkippedErrors();
                        if (data && data.data && data.data.commentData) {
                            OutsourcedCommentSaveService.saveComments(data.data.commentData, extractedComments);
                        }
                        $scope.back();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(parent.trns.SaveSuccess)
                                .position("bottom right")
                                .hideDelay(10000)
                        );
                    }, function (data) {
                        OutsourcedCommentSaveService.restoreComments($scope.data.dnh, extractedComments);
                        $scope.handleSkippableErrors(data);
                    });
                }
                else {
                    $mdDialog.show({
                        templateUrl: 'modules/deliverynote/templates/closeactiondialog.html',
                        targetEvent: evt,
                        locals: {parent: $scope, fromReadOnly: false, checkResult: checkResult},
                        controller: 'SaveDeliveryNoteAndCloseCtrl',
                        controllerAs: 'saveDeliveryNoteAndCloseCtrl',
                        bindToController: true,
                        clickOutsideToClose: true,
                        fullscreen: true
                    }).then(function (data) {
                        if (!isUndefined(data)) {
                            if (data.followCphId < 0) {
                                $scope.back();
                            }
                            else {
                                var check = "true";
                                var acceptPartialDelivery = "true";
                                var acceptOverShipment = "true";
                                var needsAllItems = "true";
                                if (!data.checkItems)
                                {
                                    check = "false";
                                }
                                if (!$scope.data.dnh.acceptPartialDelivery)
                                {
                                    acceptPartialDelivery = "false";
                                }
                                if (!$scope.data.dnh.acceptOverShipment)
                                {
                                    acceptOverShipment = "false";
                                }
                                if (!data.needsAllItems)
                                {
                                    needsAllItems = "false";
                                }
                                $redirect.redirectTo(null, "/deliverycomplaint/" + data.followCphId + "/" + $scope.data.dnh.id + "/0/" + check + "/" +
                                    acceptPartialDelivery + "/" + acceptOverShipment + "/" + needsAllItems);
                            }
                        }
                    });
                }
            }
        });
    };

    $scope.closeFunction = function () {
        $scope.back();
        $mdToast.show(
            $mdToast.simple()
                .textContent($scope.trns.SaveSuccess)
                .position("bottom right")
                .hideDelay(10000)
        );
    };

    $scope.saveDeliveryNote = function () {
        var extractedComments = OutsourcedCommentSaveService.extractComments($scope.data.dnh);

        var dataObj = {
            data: $scope.data,
            skippedErrors: $scope.skipErrors
        };
        return dataGen.post({}, dataObj, "/deliverynote/save").then(function (commentData) {
            $scope.clearSkippedErrors();
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments).then($scope.closeFunction);
            }
            else {
                $scope.closeFunction();
            }
        }, function (data) {
            OutsourcedCommentSaveService.restoreComments($scope.data.dnh, extractedComments);
            $scope.handleSkippableErrors(data);
        });
    };

    $scope.handleSkippableErrors = function(data) {
        if (!$scope.skipErrors) {
            $scope.clearSkippedErrors();
        }
        if (data.errors) {
            angular.forEach(data.errors, function (error) {
                if (error && error.code) {
                    $scope.skipErrors.push(error.code);
                }
            })
        }
    };

    $scope.clearSkippedErrors = function() {
        $scope.skipErrors = [];
    };

    $scope.getSelectedIds = function () {
        var i = 0;
        var selectedIds = [];
        var selectedItems = selectedListItems.getSelectedItems();
        while (i < selectedItems.length) {
            if (selectedItems[i].pohId) {
                selectedIds.push({id: selectedItems[i].pohId});
            }
            // got here from simple prs list
            var pohIds = selectedItems[i].pohIds;
            if (pohIds && pohIds.value) {
                selectedIds = selectedIds.concat(pohIds.value);
            }
            i++;
        }
        return selectedIds;
    };

    $scope.getOrderItemIds = function () {
        var i = 0;
        var selectedIds = [];
        while (i < orderItemIds.length) {
            if (orderItemIds[i].poiId) {
                selectedIds.push({id: orderItemIds[i].poiId});
            }
            i++;
        }
        return selectedIds;
    };

    $scope.getDeliveryNoteHeadData = function () {
        if ($routeParams.messages !== null && $routeParams.messages !== undefined) {
            //indicates oci hook
            dataGen.getData($scope, {}, "/deliverynote/getdto", function () {
                if ($routeParams.messages) {
                    var messages = $routeParams.messages.substring(1, $routeParams.messages.length - 1).split(",");
                    if (messages.length > 0 && messages[0].length > 0) {
                        ToastService.openStandardToast($scope.trns["message_" + messages[0].trim()]);
                    }
                }
                if ($routeParams.warnings) {
                    var warnings = $routeParams.warnings.substring(1, $routeParams.warnings.length - 1).split(",");
                    if (warnings.length > 0 && warnings[0].length > 0) {
                        var warningsTranslated = [];
                        for (var i = 0; i < warnings.length; i++) {
                            warningsTranslated.push({warning: $scope.trns["warning_" + warnings[i].trim()]});
                        }
                        $errorHandler.showWarnings(warningsTranslated);
                    }
                }
                if ($routeParams.errors) {
                    var errors = $routeParams.errors.substring(1, $routeParams.errors.length - 1).split(",");
                    if (errors.length > 0 && errors[0].length > 0)
                    {
                        var errorsTranslated = [];
                        for (var j = 0; j < errors.length; j++) {
                            errorsTranslated.push({error: $scope.trns["error_" + errors[j].trim()]});
                        }
                        $errorHandler.showErrors(errorsTranslated, null, null, false);
                    }
                }

                if ($scope.data.dnh.dialogState === 1) {
                    $scope.skippedFirstDialog = true;
                    $scope.initSecondDialog();
                }
                else {
                    $scope.filterOrder($scope.data.dnh.supplierCompany.selected.id, $scope.data.dnh.deliveryCompany.selected.id);
                    $scope.dialogState = 0;
                }
                self.initButtonDefinition();
            });
        }
        else if (dnhId) {
            dataGen.getData($scope, {id: $routeParams.id}, "/deliverynote/view").then(function () {
                $scope.data.dnh.previousLocation = previousLocation;
                $scope.data.dnh.dialogState = 1;
                self.initButtonDefinition();
                $scope.skippedFirstDialog = true;
                $scope.initSecondDialog();
            });
        }
        else if (orderItemIds && orderItemIds.length) {
            dataGen.getData($scope, {selected: [$scope.getOrderItemIds()]}, "/deliverynote/byorderitems/viewHead", function () {
                $scope.data.dnh.previousLocation = previousLocation;
                self.initButtonDefinition();
                if ($scope.data.dnh.dialogState === 1) {
                    $scope.skippedFirstDialog = true;
                    $scope.initSecondDialog();
                }
                else {
                    $scope.filterOrder($scope.data.dnh.supplierCompany.selected.id, $scope.data.dnh.deliveryCompany.selected.id);
                    $scope.dialogState = 0;
                }
            });
        }
        else {
            var pohIds;
            if (!pohid) {
                pohIds = $scope.getSelectedIds()
            }
            else {
                pohIds = [{id: pohid}]
            }

            dataGen.getData($scope, {selected: [pohIds]}, "/deliverynote/" + "purchaseorderlist" + "/viewHead", function () {
                $scope.data.dnh.previousLocation = previousLocation;
                if ($scope.data.dnh.dialogState === 1) {
                    $scope.skippedFirstDialog = true;
                    $scope.initSecondDialog();
                }
                else {
                    $scope.filterOrder($scope.data.dnh.supplierCompany.selected.id, $scope.data.dnh.deliveryCompany.selected.id);
                    $scope.dialogState = 0;
                }
                self.initButtonDefinition();
                // if(!$scope.data.dnh.comments) {
                //     $scope.data.dnh.comments = [];
                // }
            });
        }
    };

    $scope.getDeliveryNoteItemData = function () {
        var dataObj = {
            data: $scope.data,
            selected: $scope.getSelectedIds()
        };

        dataGen.post($scope, dataObj, "/deliverynote/purchaseorderlist/viewItems", function () {
            $scope.initSecondDialog();
        });
    };

    $scope.delete = function () {
        var params = {
            id: $scope.data.dnh.id
        };
        return dataGen.postAsForm({}, params, "/deliverynote/delete").then(function () {
            $mdToast.show($mdToast.simple()
                .textContent($scope.trns.deleteSuccess)
                .position("bottom right")
                .hideDelay(10000));
            $scope.back();
        });
    };

    $scope.back = function () {
        if ($scope.data.dnh.previousLocation) {
            $redirect.redirectTo(null, $scope.data.dnh.previousLocation)
        }
        else {
            BackService.back();
        }
    }

    $scope.initSecondDialog = function () {
        $scope.dialogState = 1;
    };
    $scope.getDeliveryNoteHeadData();

    self.openProductReplaceDialog = function (event) {
        self.openProductSelectDialog(event, true)
    };

    self.openProductAdditionalDialog = function (event) {
        self.openProductSelectDialog(event, false)
    };

    self.openProductSelectDialog = function (event, forReplacement) {
        var openAmount;
        if (forReplacement) {
            var selectedItems = $filter('filter')($scope.data.dnh.deliveryNoteItems, {selected: true});
            openAmount = selectedItems[0].openAmount;
        }

        $mdDialog.show({
            controller: "DeliveryNoteReplacementChoiceCtrl",
            controllerAs: 'deliveryNoteReplacementChoiceCtrl',
            templateUrl: 'modules/purchaseorder/templates/deliverynote-replacement-choice.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                openAmount: openAmount,
                forReplacement: forReplacement,
                trns: $scope.trns,
                articleNumberRequired: $scope.data.dnh.supplierNoRequired,
                dialogData: $scope.data
            },
            bindToController: true
        }).then(function (dialogData) {
            if (!dialogData) {
                var config = {
                    title: forReplacement ? $scope.trns.substituteTitle : $scope.trns.additionalArticleTitle,
                    locals: {
                        supplier: impactX.isDefined($scope, 'data.dnh.supplierCompany.entries')[0],
                        trns: $scope.trns
                    },
                    targetEvent: event
                };
                ProductSelectionService.open(config).then(function (productData) {
                    if (productData) {
                        addNewDeliveryNoteItem(generateDNIObject(productData), forReplacement);
                    }
                });
            }
            else if (!dialogData.ociJump && dialogData.freeformProduct){
                addNewDeliveryNoteItem(dialogData.freeformProduct, forReplacement)
            }
            else if (dialogData.ociJump) {
                $redirect.redirectTo(null, "/ocijump");
            }

            function generateDNIObject(product) {
                return {
                    bundlePosition: '',
                    deliveredAmount: {
                        value: 0,
                        unitSingular: product.basketLink.price.orderUnit,
                        unitPlural: product.basketLink.price.orderUnitPlural
                    },
                    finalDelivery: false,
                    openAmount: 0,
                    replacedAmount: 0,
                    orderedAmount: 0,
                    poiIds: [],
                    productName: {
                        value: product.name,
                        readOnly: true
                    },
                    proId: product.id,
                    priIds: [],
                    supplierNo: {
                        value: product.supplierNo,
                        readOnly: true
                    },
                    canDelete: true
                }
            }

            function addNewDeliveryNoteItem(deliveryNoteItem, forReplacement) {
                if (deliveryNoteItem) {
                    if (forReplacement) {
                        $scope.selectedItems[0].deliveredAmount.value = 0;
                        deliveryNoteItem.deliveredAmount.value = $scope.selectedItems[0].openAmount;
                        deliveryNoteItem.replacedAmount = $scope.selectedItems[0].openAmount;
                        deliveryNoteItem.isReplacement = true;
                        $scope.selectedItems[0].replacementProduct = deliveryNoteItem;
                    }
                    else {
                        deliveryNoteItem.isAdditional = true;
                        $scope.data.dnh.deliveryNoteItems.push(deliveryNoteItem);
                    }
                    deselectItem(deliveryNoteItem);
                    ToastService.openStandardToast(TranslationService.get('addSuccess'));
                }

            }
        });
    };

    self.showDetailDialog = function (event) {
        $mdDialog.show({
            controller: "DeliveryNoteItemDetailCtrl",
            controllerAs: 'deliveryNoteItemDetailCtrl',
            templateUrl: 'modules/deliverynote/templates/deliverynote-item-detail.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                item: JSON.parse(JSON.stringify($scope.selectedItems[0])),
                trns: $scope.trns,
                readOnly: false
            }
        }).then(function (returned) {
            var itemReturn = returned.item;
            $scope.selectedItems[0].supplierNo = itemReturn.supplierNo;
            $scope.selectedItems[0].productName = itemReturn.productName;
            $scope.selectedItems[0].attributes = itemReturn.attributes;
            $scope.selectedItems[0].control = itemReturn.control;
        });
    };

    self.showSerialNumberDialog = function (event) {
        $mdDialog.show({
            controller: "DeliveryNoteSerialNumberCtrl",
            controllerAs: 'deliveryNoteSerialNumberCtrl',
            templateUrl: 'modules/deliverynote/templates/deliverynote-serial-number.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                item: JSON.parse(JSON.stringify($scope.selectedItems[0])),
                trns: $scope.trns,
                readOnly: false
            }
        }).then(function (returned) {
            var itemReturn = returned.item;
            $scope.selectedItems[0].dniInfoItems = itemReturn.dniInfoItems;
        });
    };

    self.canSave = function() {
        return $scope.dialogState === 1 && $scope.data.dnh.deliveryNoteItems.length > 0 && !$scope.data.dnh.forceCloseDeliveryNote ;
    };
    self.canSaveAndClose = function() {
        return $scope.dialogState === 1 && $scope.data.dnh.closeRight && $scope.data.dnh.deliveryNoteItems.length > 0;
    };

    self.canAddAttachments = function() {
        return $scope.data.dnh.canAddAttachments &&
            !($scope.data.dnh.comments.internalComments.comments.length > 0 || $scope.data.dnh.comments.internalComments.newComments.length > 0);
    };

    self.canDelete = function() {
        return $scope.data.dnh.id > 0 && $scope.data.dnh.canDelete;
    };

    self.canAddArticle = function() {
        return $scope.data.dnh.enableAdditionalItems && $scope.dialogState === 1;
    };

    self.canReplaceArticle = function() {
        return $scope.data.dnh.enableReplacementItems && self.oneItemSelected() && !$scope.selectedItems[0].isReplacement && !$scope.selectedItems[0].isAdditional;
    };

    self.oneItemSelected = function() {
        return $scope.dialogState === 1 && $scope.selectedItems.length === 1;
    };

    self.canPrint = function() {
        return $scope.data.dnh.id > 0 && $scope.printTokens.delivery;
    };

    self.initButtonDefinition = function () {
        $scope.showAttachments = impactX.isDefined($scope, 'data.dnh.comments.internalComments.comments.length')>0;
        $scope.buttonDefinition = [
            {label: $scope.trns.back, action: $scope.back, type: 'dialogaction'},
            {label: $scope.trns.save, action: $scope.saveDeliveryNote, type:'validation', condition: self.canSave, params: {form: $scope.dialogData}},
            {label: $scope.trns.attachments, action: $scope.toggleAttachments, type:'dialogaction', condition: self.canAddAttachments},
            {label: $scope.trns.saveAndClose, action: $scope.saveAndCloseDeliveryNoteDialog, type:'validation', condition: self.canSaveAndClose, params: {form: $scope.dialogData}},
            {label: $scope.trns.delete, action: $scope.delete, type:'dialogaction', condition: self.canDelete},
            {label: $scope.trns.additionalArticle, action: self.openProductAdditionalDialog, type:'dialogaction', condition: self.canAddArticle},
            {label: $scope.trns.substitute, action: self.openProductReplaceDialog, type:'dialogaction', condition: self.canReplaceArticle},
            {label: $scope.trns.details, action: self.showDetailDialog, type:'dialogaction', condition: self.oneItemSelected},
            {label: $scope.trns.serialNumbers, action: self.showSerialNumberDialog, type:'dialogaction', condition: self.oneItemSelected},
            {
                label: $scope.trns.print,
                type: 'print',
                condition: self.canPrint,
                params: {
                    printToken: impactX.isDefined($scope, 'printTokens.delivery'),
                }
            }
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons($scope.buttonDefinition);
    };

    self.removeItem = function($event, item, isReplacement) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        if(self.canDeleteItem(item, isReplacement)) {
            deleteReplacement(item, isReplacement);
            if (!isReplacement) {
                $scope.data.dnh.deletedItems.push(item);
                var index = $scope.data.dnh.deliveryNoteItems.indexOf(item);
                if (index >= 0) {
                    $scope.data.dnh.deliveryNoteItems.splice(index, 1);
                }
            }
            deselectItem(item);
        }
    };

    self.recreateItem = function($event, item) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        $scope.data.dnh.deliveryNoteItems.push(item);
        var index = $scope.data.dnh.deletedItems.indexOf(item);
        if(index >= 0){
            $scope.data.dnh.deletedItems.splice(index, 1);
        }
    };

    self.canDeleteItem = function(item, isReplacement) {
        if(self.readOnly) {
            return false;
        }
        var toCheck = item;
        if(isReplacement) {
            toCheck = item.replacementProduct;
        }
        if(toCheck.isAdditional || toCheck.isReplacement){
            return toCheck.canDelete;
        }
        return $scope.data.dnh.deliveryNoteItems.filter(function(entry){
            return !entry.isAdditional;
        }).length > 1 && toCheck.canDelete;
    };

    var deleteReplacement = function(item, isReplacement) {
        if (item.replacementProduct) {
            var params = {
                id: item.replacementProduct.id
            };
            dataGen.postAsForm($scope, params, '/deliverynote/deleteitem').then(function () {
                item.deliveredAmount.value = (Number(item.deliveredAmount.value) || 0) + (Number(item.replacementProduct.deliveredAmount.value) || 0);
                item.replacementProduct = undefined;
                if (isReplacement) {
                    ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                    deselectItem(item);
                }
            });
        }
    };

    // since empty "bundlePosition"s are '' and Number('') is 0
    $scope.emptyLastComparator = function(item1, item2) {
        var num1 = Number(item1.value);
        var num2 = Number(item2.value);
        if(item2.value === '') {
            num2 = num1+1;
        }
        if(item1.value === '') {
            num1 = num2+1;
        }
        return num1 - num2;
    };

    function deselectItem(item) {
        var index = $scope.selectedItems.indexOf(item);
        if(index >= 0) {
            item.selected = false;
            $scope.selectedItems.splice(index, 0);
        }
    }
}